export default __webpack_public_path__ + "static/media/skippingRope.c587a2d9.png";